import { REDIRECT_AND_OPEN_ORDER_DRAWER_SCAN_ACTION_NAME } from '../constants/scanActionNames.const';
import { type ScanAction, type ScanActionResult } from '../types/scanAction.type';
import { type ScanEvent } from '../types/scanEvent.type';

export const createRedirectAndOpenOrderDrawerScanAction = (): ScanAction => ({
  // TODO: QPACK-462: Implement the logic to submit the order details drawer.
  execute: (scanEvent: ScanEvent): ScanActionResult => {
    // eslint-disable-next-line no-console
    console.debug('Executed Action: RedirectAndOpenOrderDrawerScanAction', scanEvent);
    return { success: true };
  },

  // TODO: QPACK-462: Implement the logic to submit the order details drawer.
  matches: () => false,

  name: REDIRECT_AND_OPEN_ORDER_DRAWER_SCAN_ACTION_NAME,
});
